import { SplitBlockIcon } from '@sparemin/blockhead';
import cn from 'classnames';
import React, { useCallback } from 'react';

import { block } from '../../utils';
import { AddAssetButtonProps } from './types';
import useAddAssetButton from './useAddAssetButton';

const AddAssetButton: React.FC<AddAssetButtonProps> = props => {
  const { trackId, style } = props;

  const { handleClick: handleAssetButtonClick, action } = useAddAssetButton({
    trackId,
  });

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      handleAssetButtonClick();
    },
    [handleAssetButtonClick],
  );

  const iconClassName = block('add-asset-button-icon');

  return (
    <div className={block('add-asset-button')} style={style}>
      <button
        className={block('add-asset-button-element')}
        onClick={handleClick}
        type="submit"
      >
        {action === 'add' ? (
          <span className={cn(iconClassName, 'glyphicon', 'glyphicon-plus')} />
        ) : (
          <SplitBlockIcon className={iconClassName} />
        )}
      </button>
    </div>
  );
};

export default AddAssetButton;
